// src/pages/TermsConditionsLotusCab.jsx
import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditionsLotusCab = () => {
  return (
    <div>
      <Helmet>
        <title>Lotus Cab - Terms & Conditions</title>
        <meta
          name="description"
          content="Read the Terms & Conditions of Lotus Cab for booking policies, cancellations, refunds, and service guidelines."
        />
        <link rel="canonical" href="https://www.lotuscab.com/terms-conditions" />
      </Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Terms & Conditions</h2>
        </div>
      </div>
    </section>



      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b> 
                  All bookings with <b>Lotus Cab</b> are subject to vehicle availability.
                  A booking is confirmed only after payment confirmation and
                  issuance of a booking reference ID.
                </p>

                <p>
                  <b className="highlight">2. Payment Terms:</b> 
                  Customers must pay the agreed fare in advance or as per
                  booking terms. Payments can be made online, via UPI,
                  bank transfer, or through authorized representatives.
                </p>

                <p>
                  <b className="highlight">3. Cancellation & Rescheduling:</b> 
                  Cancellations must be made within the allowed time frame.
                  Cancellation charges may apply depending on notice period
                  before pickup time.
                </p>

                <p>
                  <b className="highlight">4. Passenger Responsibility:</b> 
                  Passengers must provide accurate pickup details and carry
                  valid identification. Lotus Cab reserves the right to deny
                  service if incorrect information is provided.
                </p>

                <p>
                  <b className="highlight">5. Baggage Policy:</b> 
                  Standard luggage is permitted as per vehicle capacity.
                  Oversized or excess baggage may incur additional charges.
                </p>

                <p>
                  <b className="highlight">6. Safety & Conduct:</b> 
                  All passengers must wear seat belts and follow driver
                  instructions. Misbehavior, intoxication, or unsafe conduct
                  may result in trip termination without refund.
                </p>

                <p>
                  <b className="highlight">7. Service Delays:</b> 
                  Lotus Cab shall not be held responsible for delays caused
                  by traffic, weather conditions, roadblocks, or unforeseen
                  circumstances beyond control.
                </p>

                <p>
                  <b className="highlight">8. Refusal of Service:</b> 
                  Lotus Cab reserves the right to refuse service to any
                  individual violating company policies or engaging in
                  unlawful activity.
                </p>

                <p>
                  <b className="highlight">9. Fare Adjustments:</b> 
                  Additional waiting time, route deviation, tolls, parking,
                  or extra stops may result in revised fare calculations.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> 
                  All disputes shall be governed by Indian laws and fall
                  under the jurisdiction of Pune courts.
                </p>

                <h3>General Policy</h3>

                <p>
                  <b className="highlight">Booking Methods:</b> 
                  Customers can book via website, phone call, WhatsApp,
                  or authorized booking partners.
                </p>

                <p>
                  <b className="highlight">Customer Support:</b> 
                  Our support team is available to assist with bookings,
                  modifications, and service-related queries.
                </p>

                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Cancellation Charges:</b> 
                  Refunds are subject to applicable cancellation deductions
                  based on the timing of cancellation.
                </p>

                <p>
                  <b className="highlight">Refund Timeline:</b> 
                  Approved refunds will be processed within 7–10 business days
                  to the original mode of payment.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b> 
                  Failure to arrive at the scheduled pickup time without
                  prior notice will be treated as a no-show and is non-refundable.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>
              If you have any questions regarding our Terms & Conditions,
              please contact us:
            </p>
            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+918767592195">+91 8767592195</a>
              </li>
              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@lotuscab.com">
                  booking@lotuscab.com
                </a>
              </li>
              <li>
                <b>Website:</b>{" "}
                <a href="https://www.lotuscab.com" target="_blank" rel="noopener noreferrer">
                  www.lotuscab.com
                </a>
              </li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default TermsConditionsLotusCab;
